// frontend/src/components/ReturnManagement.js
import React, { useState, useEffect } from 'react';
import { processReturnApi, getTransactionDetailsApi } from '../../../Apis/Api';
import { toast } from 'react-hot-toast';
import { FiPackage, FiSearch, FiCheckCircle, FiXCircle } from 'react-icons/fi';

const ReturnManagement = () => {
  const [transactionId, setTransactionId] = useState('');
  const [transaction, setTransaction] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadTransaction = async () => {
    // try {
    //   setLoading(true);
    //   const { data } = await getTransactionDetailsApi(transactionId);
    //   setTransaction(data);
    //   setSelectedItems([]);
    // } catch (error) {
    //   toast.error('Transaction not found');
    //   setTransaction(null);
    // } finally {
    //   setLoading(false);
    // }
    toast.error('This feature is not implemented yet.');
  };

  const handleItemSelect = (item) => {
    setSelectedItems(prev => {
      const existing = prev.find(i => 
        i.productId === item.productId &&
        i.size === item.size &&
        i.color === item.color
      );
      
      if (existing) {
        return prev.filter(i => i !== existing);
      }
      
      return [...prev, {
        productId: item.productId,
        name: item.name,
        size: item.size,
        color: item.color,
        quantity: 1,
        originalPrice: item.price,
        maxQuantity: item.remainingQuantity,
        reason: ''
      }];
    });
  };

  const updateReturnItem = (index, field, value) => {
    setSelectedItems(prev => prev.map((item, i) => 
      i === index ? {
        ...item,
        [field]: field === 'quantity' ? 
          Math.min(Math.max(Number(value), 1), item.maxQuantity) : value
      } : item
    ));
  };

  const handleReturnSubmit = async () => {
    // if (!selectedItems.every(item => item.quantity > 0 && item.reason)) {
    //   toast.error('Please fill all required fields');
    //   return;
    // }

    // try {
    //   setLoading(true);
    //   const { data } = await processReturnApi({
    //     transactionId,
    //     returnedItems: selectedItems
    //   });
      
    //   toast.success(`Return processed. Refund: NPR ${data.data.refundAmount}`);
    //   setTransaction(null);
    //   setSelectedItems([]);
    //   setTransactionId('');
    // } catch (error) {
    //   toast.error(error.response?.data?.error || 'Return failed');
    // } finally {
    //   setLoading(false);
    // }
    toast.error('This feature is not implemented yet.');
  };

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6 flex items-center gap-2">
        <FiPackage /> Process Returns
      </h1>

      <div className="bg-white rounded-lg shadow p-4 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-4">
            <div className="relative">
              <FiSearch className="absolute left-3 top-3 text-gray-400" />
              <input
                type="text"
                value={transactionId}
                onChange={(e) => setTransactionId(e.target.value)}
                placeholder="Enter Transaction ID"
                className="w-full pl-10 pr-4 py-2 rounded border focus:ring-2 focus:ring-blue-500"
              />
              <button
                onClick={loadTransaction}
                disabled={!transactionId}
                className="mt-2 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:bg-gray-400"
              >
                {loading ? 'Searching...' : 'Find Transaction'}
              </button>
            </div>

            {transaction && (
              <div className="border rounded-lg p-4">
                <h3 className="font-semibold mb-2">Original Purchase</h3>
                <div className="text-sm mb-2">
                  <div>Date: {new Date(transaction.createdAt).toLocaleDateString()}</div>
                  <div>Customer: {transaction.customer.name} ({transaction.customer.phone})</div>
                  <div>Total: NPR {transaction.totalAmount.toFixed(2)}</div>
                </div>

                <div className="divide-y">
                  {transaction.items.map((item, index) => (
                    <div 
                      key={index}
                      className={`p-2 cursor-pointer ${selectedItems.some(si => 
                        si.productId === item.productId &&
                        si.size === item.size &&
                        si.color === item.color
                      ) ? 'bg-blue-50' : 'hover:bg-gray-50'}`}
                      onClick={() => handleItemSelect(item)}
                    >
                      <div className="flex justify-between items-center">
                        <div>
                          <div className="font-medium">{item.name}</div>
                          <div className="text-sm text-gray-500">
                            {item.size}/{item.color} · 
                            Available Qty: {item.remainingQuantity}
                          </div>
                        </div>
                        {selectedItems.some(si => 
                          si.productId === item.productId &&
                          si.size === item.size &&
                          si.color === item.color
                        ) ? (
                          <FiCheckCircle className="text-green-600" />
                        ) : (
                          <FiXCircle className="text-gray-400" />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="space-y-4">
            {selectedItems.length > 0 && (
              <div className="border rounded-lg p-4">
                <h3 className="font-semibold mb-4">Selected Items for Return</h3>
                
                {selectedItems.map((item, index) => (
                  <div key={index} className="mb-4 p-3 bg-gray-50 rounded">
                    <div className="flex justify-between items-start mb-2">
                      <div>
                        <div className="font-medium">{item.name}</div>
                        <div className="text-sm text-gray-500">
                          {item.size}/{item.color}
                        </div>
                      </div>
                      <div className="text-right">
                        <div>Price: NPR {item.originalPrice}</div>
                        <div className="text-sm">Max: {item.maxQuantity}</div>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-2">
                      <div>
                        <label className="block text-sm mb-1">Quantity</label>
                        <input
                          type="number"
                          min="1"
                          max={item.maxQuantity}
                          value={item.quantity}
                          onChange={(e) => updateReturnItem(index, 'quantity', e.target.value)}
                          className="w-full p-2 border rounded"
                        />
                      </div>
                      <div>
                        <label className="block text-sm mb-1">Reason</label>
                        <select
                          value={item.reason}
                          onChange={(e) => updateReturnItem(index, 'reason', e.target.value)}
                          className="w-full p-2 border rounded"
                        >
                          <option value="">Select reason</option>
                          <option>Defective</option>
                          <option>Wrong Size</option>
                          <option>Wrong Color</option>
                          <option>Customer Request</option>
                        </select>
                      </div>
                    </div>
                  </div>
                ))}

                <button
                  onClick={handleReturnSubmit}
                  disabled={loading}
                  className="w-full bg-red-600 text-white py-2 rounded hover:bg-red-700 disabled:bg-gray-400"
                >
                  {loading ? 'Processing...' : 'Submit Return'}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnManagement;